import 'babel-polyfill';
// eslint-disable-next-line
import modernizr from './modernizr';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import { CookiesProvider } from 'react-cookie';

import './styles/index.css';
import './styles/global.css';
import './styles/main.css';
import './styles/bootstrap.css';
import './styles/style.css';
import './assets/fonts/flask-font.css';
import './assets/fonts/liga.js';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import App from './App';
// import { registerServiceWorker } from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import reducers from './redux/reducers/index';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-63119625-1');
ReactGA.ga('create', 'UA-63119625-1', 'auto', { allowLinker: true });
ReactGA.ga('require', 'linker');
ReactGA.ga('linker:autoLink', ['fantasylabs.chargifypay.com']);
ReactGA.ga('send', 'pageview');
ReactGA.pageview(window.location.pathname + window.location.search);

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = compose;

const store = createStore(
    reducers,
    composeEnhancers(
        // applyMiddleware(thunk,logger)
        applyMiddleware(thunk)
    )
);

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js